import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures';
import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

// 500 ms timeout for each macro loading task, as this is the value the feature
// was rolled out with. On staging, we use 1000 ms to avoid test flakiness.co
const TIMEOUT =
	process.env.CLOUD_ENV === 'staging' ||
	process.env.CLOUD_ENV === 'branch' ||
	process.env.CLOUD_ENV === 'dev'
		? 1000
		: 500;

export const contentHeaderPreloadGuard = async (
	name: string,
	task: Promise<any>,
	noExtensionsSignal: Promise<void> = new Promise(() => {}),
): Promise<boolean> => {
	const timeout = StatsigConfigurations.getNumber(
		'confluence_frontend_preload_content_header_timeout',
		TIMEOUT,
	);

	const timeoutPromise = new Promise<boolean>((resolve) =>
		setTimeout(() => {
			if (process.env.NODE_ENV === 'production') {
				// eslint-disable-next-line no-console
				console.error(`SSR content header preload task "${name}" timed out after ${timeout}ms`);
			}
			resolve(false);
		}, timeout),
	);

	const runTask = async () => {
		await SSRMeasures.run(
			`ssr-app/prepare/preloadQuery/contentHeaderPreloadGuard:${name}`,
			() => task,
		);
		return true;
	};

	const noExtensionsSignalPromise = noExtensionsSignal.then(() => true);
	return Promise.race([timeoutPromise, noExtensionsSignalPromise, runTask()]);
};
